const FOR_YOU = [
  'Students organizing school games',
  'Expats who just arrived in UAE',
  'Casual players tired of WhatsApp chaos',
  'Anyone wanting their talent seen',
  'Weekend warriors & pickup players',
];

const NOT_FOR = [
  'You\'re happy with WhatsApp chaos',
  'You never want to meet new players',
  'You prefer random stranger platforms',
];

export default function ForWhoSection() {
  return (
    <section style={{ padding: '7rem clamp(1rem,4vw,3rem)', background: 'var(--navy2)' }}>
      <div style={{ maxWidth: 1000, margin: '0 auto' }}>
        <div className="vis" style={{ textAlign: 'center', marginBottom: '4rem' }}>
          <h2 className="section-title" style={{ fontSize: 'clamp(36px,5vw,56px)' }}>
            Who Is <span>Hadafi For?</span>
          </h2>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '2rem' }}>
          {/* For you */}
          <div className="vis card-hover" style={{
            background: 'var(--navy)', border: '1px solid rgba(232,96,74,0.2)',
            borderRadius: 12, padding: '2.5rem', position: 'relative', overflow: 'hidden',
          }}>
            <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: 3, background: 'linear-gradient(90deg,var(--coral),var(--coral3))' }} />
            <h3 style={{ fontFamily: 'var(--font-d)', fontSize: 26, fontWeight: 900, color: 'var(--coral)', textTransform: 'uppercase', letterSpacing: 1, marginBottom: '1.5rem' }}>
              ✓ Built For You
            </h3>
            {FOR_YOU.map((t, i) => (
              <div key={i} style={{ display: 'flex', gap: 10, marginBottom: '0.75rem' }}>
                <span style={{ color: 'var(--coral)', flexShrink: 0, marginTop: 2 }}>→</span>
                <p style={{ color: 'var(--muted)', fontSize: 15 }}>{t}</p>
              </div>
            ))}
          </div>

          {/* Not for */}
          <div className="vis card-hover" style={{
            background: 'rgba(13,27,42,0.6)', border: '1px solid rgba(122,155,181,0.12)',
            borderRadius: 12, padding: '2.5rem', position: 'relative', overflow: 'hidden',
          }}>
            <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: 3, background: 'var(--slate)' }} />
            <h3 style={{ fontFamily: 'var(--font-d)', fontSize: 26, fontWeight: 900, color: 'var(--slate)', textTransform: 'uppercase', letterSpacing: 1, marginBottom: '1.5rem' }}>
              Not For You If...
            </h3>
            {NOT_FOR.map((t, i) => (
              <div key={i} style={{ display: 'flex', gap: 10, marginBottom: '0.75rem' }}>
                <span style={{ color: 'var(--slate)', flexShrink: 0 }}>—</span>
                <p style={{ color: 'var(--slate)', fontSize: 15 }}>{t}</p>
              </div>
            ))}
            <p style={{
              color: 'var(--muted)', fontSize: 13, marginTop: '1.5rem', fontStyle: 'italic',
              borderTop: '1px solid rgba(122,155,181,0.1)', paddingTop: '1rem',
            }}>
              "Hadafi is for people who want better organization WITHOUT losing the community feel. Stick with WhatsApp if you're happy with chaos. Seriously."
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
